import { ref } from '@vue/composition-api'
import boyStatusApi from '@/services/api/boyStatus'

export default function useAffectedResults(entityType) {
  const state = ref(null)
  const results = ref([])
  const otherResults = ref([])
  const loading = ref(false)
  const previewing = ref(false)
  const previewed = ref(false)
  const recalculating = ref(false)

  async function fetchAffected(entityId, stateId) {
    loading.value = true
    try {
      const fetcher = entityType === 'horse' ? boyStatusApi.horseAffectedResults : boyStatusApi.riderAffectedResults
      const { data } = await fetcher(entityId, stateId)
      state.value = data.data.state
      results.value = data.data.results
      otherResults.value = []
      previewed.value = false
    } finally {
      loading.value = false
    }
  }

  async function preview(entityId, stateId) {
    previewing.value = true
    try {
      const fetcher = entityType === 'horse' ? boyStatusApi.horseRecalculatePreview : boyStatusApi.riderRecalculatePreview
      const { data } = await fetcher(entityId, stateId)
      results.value = data.data.results
      otherResults.value = data.data.other_results
      previewed.value = true
    } finally {
      previewing.value = false
    }
  }

  async function confirmRecalculate(entityId, stateId) {
    recalculating.value = true
    try {
      const fetcher = entityType === 'horse' ? boyStatusApi.horseRecalculate : boyStatusApi.riderRecalculate
      const { data } = await fetcher(entityId, stateId)
      return data.message
    } finally {
      recalculating.value = false
    }
  }

  return {
    state, results, otherResults, loading, previewing, previewed, recalculating, fetchAffected, preview, confirmRecalculate
  }
}



// WEBPACK FOOTER //
// ./src/composables/useAffectedResults.js